/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * SwitchIcon
 */
export default class SwitchIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M3 12c.6 0 1-.4 1-1V9c0-1.7 1.3-3 3-3h11.6l-2.3 2.3c-.4.4-.4 1 0 1.4.2.2.4.3.7.3.3 0 .5-.1.7-.3l4-4c.1-.1.2-.2.2-.3.1-.2.1-.5 0-.8-.1-.1-.1-.2-.2-.3l-4-4c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4L18.6 4H7C4.2 4 2 6.2 2 9v2c0 .6.4 1 1 1zm18 0c-.6 0-1 .4-1 1v2c0 1.7-1.3 3-3 3H5.4l2.3-2.3c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0l-4 4c-.1.1-.2.2-.2.3-.1.2-.1.5 0 .8.1.1.1.2.2.3l4 4c.2.2.4.3.7.3.3 0 .5-.1.7-.3.4-.4.4-1 0-1.4L5.4 20H17c2.8 0 5-2.2 5-5v-2c0-.6-.4-1-1-1z"/><g fillRule="evenodd"><use/><use fillRule="nonzero"/></g></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

